export default {
	name: 'app-pairing',
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {},
	methods: {
		showAPIKey() {}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/app-pairing/script.js